//https://swiperjs.com/
import Swiper from 'swiper';
import {Navigation, Keyboard, A11y} from 'swiper/modules';

//import swiper styles
import 'swiper/css';
//import 'swiper/css/navigation';
import 'swiper/css/a11y';

const carousels = document.querySelectorAll('.js-card-slider');

carousels.forEach((carousel, index) => {

    let slider = carousel.querySelector('.card-swiper');
    let prev = carousel.querySelector('.swiper-button-prev');
    let next = carousel.querySelector('.swiper-button-next');

    const cardSwiper = new Swiper(slider, {
        modules: [Navigation, Keyboard, A11y ],
        slidesPerView: 1,
        spaceBetween: 16,
        speed: 1000,
        loop: false,
        keyboard: {
            enabled: true
        },
        navigation: {
            prevEl: prev,
            nextEl: next
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
        },
        breakpoints: {
            700: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            // when window width is >= 1200px
            1000: {
                slidesPerView: 3,
                spaceBetween: 30,
            }
        }
    });

});